var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pessoa-box',{staticClass:"no-border box-actions-planejado"},[_c('div',{staticClass:"c-center"},[_c('h5',[_vm._v("Planejamento")])]),_c('p',[_vm._v("Não há nenhuma atividade futura")]),_c('div',{staticClass:"c-center"})])
}
var staticRenderFns = []

export { render, staticRenderFns }